import axios from 'axios'
import router from '@/router'

const instance = axios.create({
    baseURL : process.env.NODE_ENV === 'production' ? `/` : '/dev',
    timeout : 60000
})

// 响应拦截器--（处理返回的数据）
instance.interceptors.response.use(response => {
    if (response.data.code !== 200) {
        switch (response.data.code){
            case 556:   // 处理token超时或异常，重新登陆
                MessageBox.confirm(response.data.msg ,'系统提示', {
                    type: 'warning'
                }).then(() => {
                    router.replace({
                        path: '/home'
                    })
                })
                afterExit();

                break
            default:
                return response
            }
    }
    else {
        return response
    }
 
  }, (error) => {
    // 对响应错误做点什么
    console.log(error);
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      this.$message.error("服务器异常，请稍后重试");
      return Promise.reject('服务器异常，请稍后重试');
    } else {
      // Something happened in setting up the request that triggered an Error
      this.$message.error("网络异常，请稍后重试");
      return Promise.reject('网络异常，请稍后重试');
    }
  }
)
export default instance


// WEBPACK FOOTER //
// ./src/util/request.js